import { DatePicker as MantineDatePicker } from '@mantine/dates';
import { ChevronRight, ChevronLeft } from 'lucide-react';

export const DatePicker = MantineDatePicker.extend({
	defaultProps: {
		nextIcon: <ChevronRight />,
		previousIcon: <ChevronLeft />,
	},
});
